module.exports = __webpack_public_path__ + "assets/img/driver-btn-d87711bc.png";